import React from 'react';
import { trackEvent } from 'src/web/Utils/trackEvent';
import styled from 'styled-components';
import { HeroBannerImage } from '.';

const Wrapper = styled.section`
  background-color: #e6f7ff;
  padding: 4rem 0;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #111;
`;

const Subtitle = styled.p`
  font-size: 1.25rem;
  font-weight: 500;
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
`;

const Description = styled.p`
  color: #333;
  margin-bottom: 1rem;
`;

const HeroImage = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;

  img {
    width: 100%;
    border-radius: 12px;
  }

  .badge-icon {
    position: absolute;
    width: 40px;
    height: 40px;
    background-color: white;
    border-radius: 50%;
    padding: 5px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  /* Contoh posisi */
  .icon-1 {
    top: 0;
    left: -20px;
  }
  .icon-2 {
    top: 50%;
    left: -30px;
    transform: translateY(-50%);
  }
  .icon-3 {
    bottom: 0;
    left: 0;
  }
`;

export default function HeroBanner() {
  const handleBelajar = (e) => {
    e.preventDefault();
    // eslint-disable-next-line no-unused-expressions
    document.getElementById('subscription')?.scrollIntoView({
      behavior: 'smooth',
    });

    trackEvent({
      eventName: 'button_click_mulai_belajar_sekarang',
      params: { item_category: 'mesx' },
    });
  };

  return (
    <Wrapper>
      <div className="container px-3 px-md-4 px-lg-5">
        <div className="row align-items-center">
          {/* Kiri: Gambar + Icon */}
          <div className="col-md-6 text-center mb-4 mb-md-0">
            <HeroImage>
              <img src={HeroBannerImage} alt="Hero" />
            </HeroImage>
          </div>

          {/* Kanan: Konten */}
          <div className="col-md-6 text-md-left text-center">
            <Title>MyEduSolveX</Title>
            <Subtitle>Upgrade Kemampuanmu, Kapanpun, Dimanapun!</Subtitle>
            <Description>
              Akses semua materi di berbagai bidang. Belajar mandiri melalui video pembelajaran dan
              dapatkan sertifikat penyelesaian di akhir kelas.
            </Description>
            <div>
              <div>
                <a
                  href={'/courses'}
                  className="btn font-weight-bold text-white mr-3 btn-pink"
                  onClick={() => {
                    trackEvent({
                      eventName: 'button_click_lihat_semua_kelas',
                      params: { item_category: 'mesx' },
                    });
                  }}
                >
                  Lihat semua kelas
                </a>
                <a
                  href="#subscription"
                  onClick={handleBelajar}
                  className="btn font-weight-bold text-white mr-3 btn-tosca"
                >
                  Mulai Belajar Sekarang
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}
